// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-button{color:#000;font-weight:700;margin:0 2px}.custom-button:hover{background:#9d57f4;color:#fff;font-weight:700}.tiptap-vuetify-editor__content{min-height:200px}.tiptap-vuetify-editor{border:1px solid #c4c4c4!important}.ProseMirror{min-height:200px}", ""]);
// Exports
module.exports = exports;
